// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"673":"d156cffa59221c44","808":"3157034238434bad","844":"d400b51667fdb451","897":"5699de5a3a3324e9","906":"58312053f64ba8d3"}[chunkId] + ".js";
};